import { getSessionData } from '@/auth/authUtil';
import { countVisitorChat, getVisitorChatCount } from '@/pages/chat/api';
import { RootState } from '@/typings/system';
import { ElMessageBox, MessageBoxAction } from '@qsxy/element-plus-react';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

export const useCheckCount = () => {
	const loginUser = useSelector<RootState, RootState['user']>(state => state.user ?? {});
	const navigate = useNavigate();

	/** 校验会话次数 */
	const checkChatCount = useCallback(
		async (isQuery?: boolean) => {
			let isAllowed = true;
			const { usage } = getSessionData();
			if (loginUser?.isVisitor) {
				const count = await (isQuery ? getVisitorChatCount({ id: loginUser.id }) : countVisitorChat({ id: loginUser.id }));
				isAllowed = count <= 3;
			} else {
				isAllowed = usage?.requestCount > 0;
			}
			if (!isAllowed) {
				navigate('/chat');
				ElMessageBox.alert(
					`您今日的会话次数已用尽，如需更多体验，${
						loginUser?.isVisitor
							? '请前往注册账号，享受更多次数'
							: `${usage?.versionType == 0 ? '请前往升级为专业版享受更多次数或等待明天重置次数' : '请等待明天重置次数'}`
					}`,
					'温馨提示',
					{
						type: 'warning',
						confirmButtonText: '去登录',
						cancelButtonText: '去注册',
						distinguishCancelAndClose: true,
					},
				)
					.then(() => navigate('/login'))
					.catch((action: MessageBoxAction) => {
						if (action === 'cancel') {
							navigate('/register');
						}
					});
				return false;
			}
			return true;
		},
		[loginUser.id, loginUser?.isVisitor, navigate],
	);

	return { checkChatCount };
};
